import React, {useEffect} from "react";
import moment from "moment";
import {decoder, filterPayType, filterTree,filterOnAccount} from "../../../utils/decoder"
import {Button, Drawer, Form, Input, Select} from "antd";
import {useModel} from "../../../models";
import { debounce } from "lodash";

const layout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 18,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 6,
        span: 18,
    },
};

const AreaForm = () => {
    const [{payTypeDict},] = useModel("cmDict");
    const [
        {selectedDocument, formData,},
        {settle, setSelectedDocument, setPaymentDrawerVisible,}
    ] = useModel("purchaseRo");
    const [form] = Form.useForm();
    useEffect(() => {
        const payDate = moment().format("YYYY-MM-DD");
        const {receivableAmount} = formData;
        const {
            returnCode,
            createTime,
            supplierCode,
            supplierName,
            paidAmount = 0,
            paymentMethod
        } = selectedDocument;


        form.setFieldsValue({
            returnCode,
            createTime,
            supplierCode,
            supplierName,
            receivableAmount,
            payType: paymentMethod,
            paidAmount,
            payDate,
        });
        /*form.setFieldsValue({returnCode: selectedDocument.returnCode});
        form.setFieldsValue({createTime: selectedDocument.createTime});
        form.setFieldsValue({supplierCode: selectedDocument.supplierCode});
        form.setFieldsValue({supplierName: selectedDocument.supplierName});
        form.setFieldsValue({payDate: moment().format("YYYY-MM-DD")});
        form.setFieldsValue({receivableAmount: selectedDocument.receivableAmount});
        form.setFieldsValue({paidAmount: selectedDocument.paidAmount});*/

    }, [selectedDocument]);


    const onFinish = debounce(() => {
        form.validateFields().then(data => {
            const {payType, payDesc} = data;
            settle({
                showMsg: true, data: {
                    id: selectedDocument.id,
                    payTypeCode: payType,
                    payDesc,
                }
            }).then(ret => {
                if (ret) {
                    setSelectedDocument({
                        ...selectedDocument,
                        paidAmount: selectedDocument.receivableAmount,
                        paymentMethod: form.getFieldValue("payType")
                    });
                    setPaymentDrawerVisible(false)
                }
            });
        })
    },600)

    const onClose = () => {
        setPaymentDrawerVisible(false)
    }
    return (
        <Form {...layout} form={form} name="control-hooks"
              onFinish={onFinish}>
            <Form.Item name="returnCode" label="采购退货单号">
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item name="createTime" label="制单日期">
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item name="supplierCode" label="供应商编码">
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item name="supplierName" label="供应商名称">
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item name="payDate" label="结算日期">
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item name="receivableAmount" label="应收金额">
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item name="paidAmount" label="已收金额">
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item name="payType" label="支付方式" rules={[{required: true, message: '请选择支付方式',}]}>
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择支付方式"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    // 张家口
                    options={filterOnAccount(payTypeDict)}
                    // 公司潍柴
                    // options={payTypeDict}
                />
            </Form.Item>
            <Form.Item name="payDesc" label="备注" rules={[{required: false}]}>
                <Input.TextArea/>
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">
                    确定
                </Button>
                <Button htmlType="button" onClick={onClose} className="margin-left-8">
                    取消
                </Button>
            </Form.Item>
        </Form>
    );
}
export default function () {
    const [{paymentDrawerVisible}, {setPaymentDrawerVisible}] = useModel("purchaseRo");
    return (
        <Drawer
            title="采购退货收款"
            placement="right"
            width={500}
            closable={true}
            onClose={() => {
                setPaymentDrawerVisible(false)
            }}
            visible={paymentDrawerVisible}
        >
            <AreaForm/>
        </Drawer>
    )
}